/**
 * Hook misji „Skocz z trampoliny do wody" — tylko EMIT (W9-B / QuestLayer).
 */
import type { InteractEvent } from '../../interact/index.js';

export const INTERACT_BUS_EVENT = 'pieskowo:interact';
export const POOL_QUEST_ID = 'pool_trampoline' as const;
export const POOL_TRAMPOLINE_DEF_ID = 'pool_trampoline';

export type PoolMissionPayload = {
  sceneKey: 'Pool';
  questId: typeof POOL_QUEST_ID;
  stepKind: 'trampoline_jump';
  interact: InteractEvent;
};

export function isTrampolineJumpEvent(evt: InteractEvent): boolean {
  if (evt.defId !== POOL_TRAMPOLINE_DEF_ID) return false;
  return evt.type === 'tap' || evt.type === 'intention-done';
}

export function poolMissionFromInteract(evt: InteractEvent): PoolMissionPayload | null {
  if (!isTrampolineJumpEvent(evt)) return null;
  return {
    sceneKey: 'Pool',
    questId: POOL_QUEST_ID,
    stepKind: 'trampoline_jump',
    interact: evt,
  };
}
